import Vue from 'vue'
import Router from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import VueMasonry from 'vue-masonry-css'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'

import { getUserLanguage } from '@modules/browser'

import '@/directives/custom-sticky.js'
import 'swiper/dist/css/swiper.css'

window.AppSettings = {}

Vue.use(Router)
Vue.use(VueMasonry)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease-in-out',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false

const setLanguage = () => {
  store.dispatch('languages/updateLanguage', getUserLanguage())
}

const createApp = () => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

setLanguage()
createApp()
